import { Grid } from "@mui/material";

import React, { useRef, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { UNAUTHORIZEDREQUEST } from "../../constants";
import styled from "styled-components/macro";
import Dialog from "../../components/custom/Dialog";
import DistributorForm from "./DistributorForm";

import {
  getDistributorData,
  updateDistributor,
} from "../../services/distributorService";
import Header from "../../components/custom/Header";
import { useMutation, useQuery } from "react-query";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const EditDistributor = () => {
  const { id } = useParams();
  const { data } = useQuery(["distributor", id], () => getDistributorData(id), {
    enabled: !!id,
    retry: (failureCount, error) => {
      if (error.response.status === UNAUTHORIZEDREQUEST) {
        navigate("/");
      }
    },
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const formikRef = useRef();
  const { mutate } = useMutation(updateDistributor, {
    onSettled: (data, error, variables, context) => {
      if (error) {
        setMessage(error?.response?.data?.error || error?.response?.data);
      } else {
        setMessage("Distributor edited");
        setTimeout(() => {
          setIsDialogOpen(false);
          navigate(-1);
        }, 1000);
      }
    },
  });
  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header name="Edit distributor" />
        <DistributorForm
          edit={true}
          data={data?.data}
          formikRef={formikRef}
          onSubmit={async () => {
            setMessage("Updating distributor... please wait...");
            setIsDialogOpen(true);
            mutate({ id: id, data: formikRef?.current?.values });
          }}
        />
      </StyledContainer>
      <Dialog
        showButton={false}
        action={() => setIsDialogOpen(false)}
        onClose={() => setIsDialogOpen(false)}
        open={isDialogOpen}
      >
        {message}
      </Dialog>
    </>
  );
};

export default EditDistributor;
